"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
var _hover = require("../../hooks/hover");
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _excluded = ["nodeRef", "disabled", "setFieldValue", "options"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MAX_SUGGESTION_NUMBER = 6;
var _default = exports["default"] = (0, _formik.connect)(function (_ref) {
  var name = _ref.name,
    type = _ref.type,
    placeholder = _ref.placeholder,
    value = _ref.value,
    content = _ref.content,
    options = _ref.options,
    onError = _ref.onError,
    onRemove = _ref.onRemove,
    validator = _ref.validator,
    formik = _ref.formik;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    disabled = _useState2[0],
    setDisable = _useState2[1];
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  var nodeRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    // While typing, it won't trigger this effect
    // The value only changes when
    // 1. Click enter
    // 2. On blur
    // 3. Select a item from the dropdown
    setDisable(!!value || type === 'text');
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, targetProps, {
    ref: nodeRef,
    className: "flex items-center min-w-0 py-4 pl-6 m-2 rounded-lg shadow-lg bg-app dark:bg-card"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-semibold text-lg text-dark"
  }, disabled ? content || value : /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(Input, (0, _extends2["default"])({}, field, {
        nodeRef: nodeRef,
        disabled: disabled,
        setDisable: setDisable,
        setFieldValue: function setFieldValue(v) {
          try {
            validator(v);
            form.setFieldValue(field.name, v);
            setDisable(true);
          } catch (e) {
            if ((0, _isFunction["default"])(onError)) onError(e);
          }
        },
        placeholder: placeholder,
        options: options
      }));
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('px-4 text-gray-light opacity-0', {
      'opacity-100': hovered
    })
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    size: "small",
    onMouseDown: function onMouseDown(event) {
      return event.preventDefault();
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      onRemove();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))));
});
function Input(_ref3) {
  var nodeRef = _ref3.nodeRef,
    disabled = _ref3.disabled,
    setFieldValue = _ref3.setFieldValue,
    _ref3$options = _ref3.options,
    options = _ref3$options === void 0 ? [] : _ref3$options,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var itemsRef = (0, _react.useRef)([]);
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    escape = _useState6[0],
    setEscape = _useState6[1];
  var _useState7 = (0, _react.useState)(-1),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    selected = _useState8[0],
    setSelected = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    enableOnBlur = _useState10[0],
    setOnBlur = _useState10[1];
  var _useState11 = (0, _react.useState)({}),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    suggestionStyle = _useState12[0],
    setSuggestionStyle = _useState12[1];
  (0, _react.useEffect)(function () {
    if (!nodeRef.current) return;
    var _nodeRef$current$getB = nodeRef.current.getBoundingClientRect(),
      width = _nodeRef$current$getB.width;
    setSuggestionStyle({
      width: width
    });
  }, []);
  var trimedValue = (0, _react.useMemo)(function () {
    return (value || '').trim().toLowerCase();
  }, [value]);
  var matches = (0, _react.useMemo)(function () {
    return options.reduce(function (prev, curr) {
      if (prev.length > MAX_SUGGESTION_NUMBER) return prev;
      var lowerCaseCurr = curr.toLowerCase();
      if (!!trimedValue && trimedValue !== lowerCaseCurr && lowerCaseCurr.includes(trimedValue)) {
        return [].concat((0, _toConsumableArray2["default"])(prev), [curr]);
      }
      return prev;
    }, []).sort(function (a, b) {
      return a < b ? -1 : 1;
    });
  }, [options, trimedValue]);
  function handleOnSetValue(e) {
    e.stopPropagation();
    if (selected > -1) {
      setFieldValue(matches[selected]);
    } else if (!!trimedValue) {
      setFieldValue(value.trim());
    }
  }
  function handleOnKeyDown(e) {
    e.stopPropagation();
    switch (e.key) {
      // Set the field value once click enter
      case 'Enter':
        handleOnSetValue(e);
        break;
      // Matched items navigation
      case 'ArrowUp':
      case 'ArrowDown':
        e.preventDefault();
        var step = e.key === 'ArrowUp' ? -1 : 1;
        var nextIndex = selected + step;
        if (nextIndex < 0) nextIndex = matches.length - 1;
        nextIndex = nextIndex % matches.length;
        setSelected(nextIndex);
        var targetNode = itemsRef.current[nextIndex];
        if (!!targetNode) {
          targetNode.scrollIntoView({
            block: 'nearest'
          });
        }
        break;
      // Reset all the state
      case 'Escape':
        setOnBlur(true);
        setEscape(true);
        setSelected(-1);
        break;
      default:
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
    autoFocus: true,
    type: "text",
    value: value,
    autoComplete: "off",
    disabled: disabled
    // Disable the onBlur handler
    // When click the item in the list
    ,
    onBlur: function onBlur(e) {
      return (enableOnBlur || !(matches.length > 0)) && handleOnSetValue(e);
    },
    onKeyDown: handleOnKeyDown,
    onChange: function onChange(e) {
      setValue(e.target.value);
      setSelected(-1);
      if (escape) setEscape(false);
    },
    className: (0, _classnames["default"])('font-semibold rounded-none border-b-2 border-primary', 'bg-transparent opacity-50 focus:opacity-100 hover:opacity-100', {
      hidden: disabled
    })
  })), /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    open: !escape && matches.length > 0,
    anchorEl: nodeRef.current,
    placement: "bottom",
    modifiers: {
      flip: {
        enabled: false
      },
      offset: {
        enabled: true,
        offset: '0,-16'
      }
    },
    style: {
      zIndex: 10000
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: suggestionStyle,
    className: "left-0 bg-card shadow-lg rounded-lg py-4"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "overflow-y-auto overflow-x-hidden",
    style: {
      maxHeight: 100
    }
    // Enable/Disable the onBlur handler
    ,
    onMouseEnter: function onMouseEnter() {
      return setOnBlur(false);
    },
    onMouseLeave: function onMouseLeave() {
      setOnBlur(true);
      setSelected(-1);
    }
  }, matches.map(function (each, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      ref: function ref(node) {
        return itemsRef.current[index] = node;
      },
      className: (0, _classnames["default"])('text-sm text-gray-light px-6 cursor-pointer', {
        'bg-secondary': selected === index
      }),
      onMouseEnter: function onMouseEnter() {
        return setSelected(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
      title: each
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "py-1 truncate",
      onClick: handleOnSetValue
    }, each)));
  })))));
}
//# sourceMappingURL=Value.js.map